import { useCallback } from 'react';
import { usePlaySounds } from './useSoundPlayer';

export function usePlayFavoriteSound() {
  const playSound = usePlaySounds();

  const playFavoriteSound = useCallback((isFavorited: boolean) => {
    if (isFavorited) {
      playSound('favorite');
      return;
    }

    playSound('removeFavorite');
  }, [playSound]);

  return playFavoriteSound;
}
